import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"
export const submitApplication = createAsyncThunk("submit-application", async (payload) => {
    const response = await api.postApplication(payload)
    return response
})

export const submitRenewalApplication = createAsyncThunk("submit-renewal-application", async (id, payload) => {
    const response = await api.postRenewalApplication(id, payload)
    return response
})

export const completeApplication = createAsyncThunk("complete-application", async (payload) => {
    const response = await api.completeApplication(payload)
    return response
})

export const postApplicationThreadedComments = createAsyncThunk("post-application-comments", async (payload) => {
    const response = await api.postApplicationThreadedComments(payload)
    return response
})

export const getApplicationThreadedComments = createAsyncThunk("get-application-comments", async (payload) => {
    const response = await api.getApplicationThreadedComments(payload)
    return response
})

export const reviewThreadedComments = createAsyncThunk("review-application-comments", async (payload) => {
    const response = await api.reviewThreadedComments(payload)
    return response
})

export const getApplications = createAsyncThunk(
    "get-applications",
    async ({ pageIndex, numberOfRecords, orderBy, descending }) => {
        const response = await api.getApplications({ pageIndex, numberOfRecords, orderBy, descending })
        return response
    }
)

export const changeApplicationStatus = createAsyncThunk("change-status-application", async ({ id, status }) => {
    const response = await api.changeApplicationStatus({ id, status })
    return response
})

export const downloadQuotePDF = createAsyncThunk("download-application-pdf", async (id) => {
    const response = await api.downloadQuotePDF(id)
    return response
})

export const downloadAppFormPDF = createAsyncThunk("download-application-form", async (id) => {
    const response = await api.downloadFormPDF(id)
    return response
})

export const renewApplication = createAsyncThunk("renew-application", async (id) => {
    const response = await api.renewApplication(id)
    return response
})

export const getApplicationsRequiringAttention = createAsyncThunk(
    "get-application-requiring-attentions",
    async ({ pageIndex, numberOfRecords, orderBy, descending }) => {
        const response = await api.getApplicationsRequiringAttention({
            pageIndex,
            numberOfRecords,
            orderBy,
            descending
        })
        return response
    }
)

export const getDashboardList = createAsyncThunk(
    "get-dashboard-list",
    async ({ pageIndex, numberOfRecords, orderBy, descending }) => {
        const response = await api.getDashboardList({ pageIndex, numberOfRecords, orderBy, descending })
        return response
    }
)

export const getRenewalsAndEmails = createAsyncThunk(
    "get-renewals-and-emails-list",
    async ({ pageIndex, numberOfRecords, orderBy, descending }) => {
        const response = await api.getRenewalsAndEmailsList({ pageIndex, numberOfRecords, orderBy, descending })
        return response
    }
)

export const searchApplications = createAsyncThunk(
    "search-applications",
    async ({ searchTerm, pageIndex, numberOfRecords, orderBy, descending }) => {
        const response = await api.searchApplications({ searchTerm, pageIndex, numberOfRecords, orderBy, descending })
        return response
    }
)

export const getApplication = createAsyncThunk("get-admin-application", async (id) => {
    const response = await api.getApplication(id)
    return response
})

export const getPriorApplication = createAsyncThunk("get-prior-application", async (id) => {
    const response = await api.getApplication(id)
    return response
})

export const reassignApplicationToUser = createAsyncThunk("reassign-application-to-user", async (payload) => {
    const response = await api.reassignUser(payload)
    return response
})

export const reassignMultipleApplicationsToUser = createAsyncThunk(
    "reassign-multiple-applications-to-user",
    async (payload) => {
        const response = await api.reassignApplicationsToUser(payload)
        return response
    }
)

export const getReportingList = createAsyncThunk("get-reporting-list", async ({ startDate, endDate }) => {
    const response = await api.getReportingList({ startDate, endDate })
    return response
})

export const exportReportingList = createAsyncThunk("export-reporting-list", async ({ startDate, endDate }) => {
    const response = await api.exportReportingList({ startDate, endDate })
    return response
})

export const uploadSignedApplicationFile = createAsyncThunk("upload-signed-application-file", async (payload) => {
    const response = await api.postSignedApplicationFile(payload.id, payload.binary)
    return response
})

export const uploadSurplusLineFiles = createAsyncThunk("upload-surplus-lines-and-tria", async (payload) => {
    const response = await api.uploadSurplusLines(payload.id, payload.binary)
    return response
})

export const uploadTriaFiles = createAsyncThunk("upload-tria-files", async (payload) => {
    const response = await api.uploadTriaFiles(payload.id, payload.binary)
    return response
})

export const uploadLossRunFile = createAsyncThunk("upload-loss-run-file", async (payload) => {
    const response = await api.postLostRunFile(payload.id, payload.binary)
    return response
})

export const bindYourQuote = createAsyncThunk("bind-quote", async (payload) => {
    const response = await api.bindYourQuote(payload)
    return response
})

export const getBindFiles = createAsyncThunk("get-bind-files", async (id) => {
    const response = await api.getBindFiles(id)
    return response
})

export const downloadLossRunsFiles = createAsyncThunk("download-loss-runs-files", async (id) => {
    const response = await api.downloadLossRuns(id)
    return response
})

export const deleteLossRunsFiles = createAsyncThunk("delete-loss-runs-files", async (id) => {
    const response = await api.deleteLossRuns(id)
    return response
})

export const downloadSurplusLinesFiles = createAsyncThunk("download-surplus-lines-files", async (id) => {
    const response = await api.downloadSurplusFiles(id)
    return response
})

export const deleteSurplusLinesFiles = createAsyncThunk("delete-surplus-lines-files", async (id) => {
    const response = await api.deleteSurplusFiles(id)
    return response
})

export const downloadTriaFiles = createAsyncThunk("download-tria-files", async (id) => {
    const response = await api.downloadTriaFiles(id)
    return response
})

export const deleteTriaFiles = createAsyncThunk("delete-tria-files", async (id) => {
    const response = await api.deleteTriaFiles(id)
    return response
})

export const downloadSignedApplicationFile = createAsyncThunk("download-signed-application-files", async (id) => {
    const response = await api.downloadSignedApplication(id)
    return response
})

export const deleteSignedApplicationFile = createAsyncThunk("delete-signed-application-files", async (id) => {
    const response = await api.deleteSignedApplication(id)
    return response
})

export const getUnderwriterReferralReasonQuestionMaps = createAsyncThunk(
    "get-underwriter-referral-reason-question-maps",
    async () => {
        const response = await api.getUnderwriterReferralReasonQuestionMaps()
        return response
    }
)

const applicationSlice = createSlice({
    name: "admin-application",
    initialState: {
        data: [],
        applicationsRequiringAttention: [],
        dashboardData: [],
        reportingData: [],
        renewalsAndEmails: [],
        totalRecords: 0,
        applicationsRequiringAttentionRecords: 0,
        dashboardDataRecords: 0,
        renewalsAndEmailsRecords: 0,
        application: {},
        additionalNamedInsureds: [],
        additionalInsured: [],
        threadedComments: [],
        underwriterReferralReasonQuestionMaps: [],
        bindFiles: { signedApplication: {}, lossRuns: [], surplusLines: [], tria: [] },
        totalRecordsOfComments: 0,
        adminApplication: {
            coverageRequested: {},
            applicantInformation: {}
        },
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateAdminApplication(state, action) {
            const { field, value } = action.payload
            if (field === "additionalNamedInsureds") {
                state.additionalNamedInsureds = value
            } else if (field === "additionalInsured") {
                state.additionalInsured = value
            } else {
                state.adminApplication = { ...state.adminApplication, [field]: value }
            }
        },
        updateApplicationData(state, action) {
            const { field, value } = action.payload
            if (field === "additionalNamedInsureds") {
                state.additionalNamedInsureds = value
            } else if (field === "additionalInsured") {
                state.additionalInsured = value
            } else {
                state.application = { ...state.application, [field]: value }
            }
        },
        removeApplicationData(state, action) {
            const fieldToRemove = action.payload
            if (state.application && typeof state.application === "object") {
                const { [fieldToRemove]: _, ...updatedApplication } = state.application
                state.application = updatedApplication
            }
        },
        resetApplicationForRenewal(state, action) {
            const keysToKeep = action.payload
            const application = state.application
            const newApplication = {}

            for (const key in application) {
                if (keysToKeep.includes(key)) {
                    newApplication[key] = application[key]
                } else {
                    newApplication[key] = null
                }
            }
            state.additionalInsured = []
            state.application = newApplication
        },
        clearApplicationData(state, action) {
            state.application = {}
            state.additionalInsured = []
            state.additionalNamedInsureds = []
        },
        clearBindingData(state, action) {
            state.bindFiles = { signedApplication: {}, lossRuns: [], surplusLines: [], tira: [] }
        },
        updateApplicationCoverageRequested(state, action) {
            const { field, value } = action.payload
            state.adminApplication = {
                ...state.adminApplication,
                coverageRequested: {
                    ...(state?.adminApplication?.coverageRequested ?? []),
                    [field]: value
                }
            }
        },
        appendAdminApplication(state, action) {
            state.data = [...state.data, action.payload]
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReportingList.fulfilled, (state, action) => {
                state.reportingData = action.payload?.records
                state.fetchStatus = "success"
                state.action = "getReportingList"
            })
            .addCase(getReportingList.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getReportingList"
            })
            .addCase(getReportingList.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getReportingList"
            })
            .addCase(exportReportingList.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "exportReportingList"
            })
            .addCase(exportReportingList.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "exportReportingList"
            })
            .addCase(exportReportingList.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "exportReportingList"
            })
            .addCase(submitApplication.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "submitApplication"
            })
            .addCase(submitApplication.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "submitApplication"
            })
            .addCase(submitApplication.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "submitApplication"
            })
            .addCase(submitRenewalApplication.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "submitRenewalApplication"
            })
            .addCase(submitRenewalApplication.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "submitRenewalApplication"
            })
            .addCase(submitRenewalApplication.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "submitRenewalApplication"
            })
            .addCase(postApplicationThreadedComments.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "postApplicationThreadedComments"
            })
            .addCase(postApplicationThreadedComments.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "postApplicationThreadedComments"
            })
            .addCase(postApplicationThreadedComments.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "postApplicationThreadedComments"
            })
            .addCase(getApplicationThreadedComments.fulfilled, (state, action) => {
                state.threadedComments = action.payload?.records || []
                state.totalRecordsOfComments = action.payload?.totalRecords || 0
                state.fetchStatus = "success"
                state.action = "getApplicationThreadedComments"
            })
            .addCase(getApplicationThreadedComments.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getApplicationThreadedComments"
            })
            .addCase(getApplicationThreadedComments.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getApplicationThreadedComments"
            })
            .addCase(reviewThreadedComments.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "reviewThreadedComments"
            })
            .addCase(reviewThreadedComments.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "reviewThreadedComments"
            })
            .addCase(reviewThreadedComments.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "reviewThreadedComments"
            })
            .addCase(getBindFiles.fulfilled, (state, action) => {
                state.bindFiles = {
                    signedApplication: action.payload?.signedApplication || {},
                    lossRuns: action.payload?.lossRuns || [],
                    surplusLines: action.payload?.surplusLines || [],
                    tria: action.payload?.tria || []
                }
                state.fetchStatus = "success"
                state.action = "getBindFiles"
            })
            .addCase(getBindFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getBindFiles"
            })
            .addCase(getBindFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getBindFiles"
            })
            .addCase(getApplications.fulfilled, (state, action) => {
                if (action.payload) {
                    state.totalRecords = action.payload.totalRecords
                    state.data = action.payload.records
                }
                state.fetchStatus = "success"
                state.action = "getApplications"
            })
            .addCase(getApplications.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getApplications"
            })
            .addCase(getApplications.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getApplications"
            })
            .addCase(getApplicationsRequiringAttention.fulfilled, (state, action) => {
                if (action.payload) {
                    state.applicationsRequiringAttentionRecords = action.payload.totalRecords
                    state.applicationsRequiringAttention = action.payload.records
                }
                state.fetchStatus = "success"
                state.action = "getApplicationsRequiringAttention"
            })
            .addCase(getApplicationsRequiringAttention.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getApplicationsRequiringAttention"
            })
            .addCase(getApplicationsRequiringAttention.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getApplicationsRequiringAttention"
            })
            .addCase(getDashboardList.fulfilled, (state, action) => {
                if (action.payload) {
                    state.dashboardDataRecords = action.payload.totalRecords
                    state.dashboardData = action.payload.records
                }
                state.fetchStatus = "success"
                state.action = "getDashboardList"
            })
            .addCase(getDashboardList.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getDashboardList"
            })
            .addCase(getDashboardList.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getDashboardList"
            })
            .addCase(getRenewalsAndEmails.fulfilled, (state, action) => {
                if (action.payload) {
                    state.renewalsAndEmailsRecords = action.payload.totalRecords
                    state.renewalsAndEmails = action.payload.records
                }
                state.fetchStatus = "success"
                state.action = "getRenewalsAndEmails"
            })
            .addCase(getRenewalsAndEmails.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getRenewalsAndEmails"
            })
            .addCase(getRenewalsAndEmails.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getRenewalsAndEmails"
            })
            .addCase(searchApplications.fulfilled, (state, action) => {
                if (action.payload) {
                    state.totalRecords = action.payload.totalRecords
                    state.data = action.payload.records
                }
                state.fetchStatus = "success"
                state.action = "searchApplications"
            })
            .addCase(searchApplications.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "searchApplications"
            })
            .addCase(searchApplications.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "searchApplications"
            })

            .addCase(getApplication.fulfilled, (state, action) => {
                //   assign localIds to additionalNamedInsureds
                let application = action.payload
                application.additionalNamedInsureds = application?.additionalNamedInsureds.map((item) => {
                    item.localId = Math.random().toString(36).substr(2, 9)
                    return item
                })

                // When editing an application created on behalf of a broker,
                // map submittedFor info into the fields used by the admin form.
                if (application?.submittedFor) {
                    // Broker Agency *
                    if (application.submittedFor.brokerageId) {
                        application.brokerageId = application.submittedFor.brokerageId
                    }
                    // Broker Contact *
                    if (application.submittedFor.id) {
                        application.brokerContactId = application.submittedFor.id
                    }
                } else if (application?.submittedForId) {
                    // Fallback: use submittedForId when submittedFor object is not present
                    application.brokerContactId = application.submittedForId
                }

                // filter additionalNamedInsureds and additionalInsured
                state.additionalNamedInsureds = application?.additionalNamedInsureds.filter(
                    (item) => item.type === "AdditionalNamedInsured"
                )
                state.additionalInsured = application?.additionalNamedInsureds.filter(
                    (item) => item.type === "AdditionalInsured"
                )

                state.application = application
                state.fetchStatus = "success"
                state.action = "getApplication"
            })
            .addCase(getApplication.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getApplication"
            })
            .addCase(getApplication.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getApplication"
            })
            .addCase(getPriorApplication.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "getPriorApplication"
            })
            .addCase(getPriorApplication.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getPriorApplication"
            })
            .addCase(getPriorApplication.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getPriorApplication"
            })
            .addCase(reassignApplicationToUser.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "reassignApplicationToUser"
            })
            .addCase(reassignApplicationToUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "reassignApplicationToUser"
            })
            .addCase(reassignApplicationToUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "reassignApplicationToUser"
            })
            .addCase(reassignMultipleApplicationsToUser.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "reassignMultipleApplicationsToUser"
            })
            .addCase(reassignMultipleApplicationsToUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "reassignMultipleApplicationsToUser"
            })
            .addCase(reassignMultipleApplicationsToUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "reassignMultipleApplicationsToUser"
            })
            .addCase(completeApplication.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "completeApplication"
            })
            .addCase(completeApplication.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "completeApplication"
            })
            .addCase(completeApplication.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "completeApplication"
            })
            .addCase(changeApplicationStatus.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "changeApplicationStatus"
            })
            .addCase(changeApplicationStatus.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "changeApplicationStatus"
            })
            .addCase(changeApplicationStatus.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "changeApplicationStatus"
            })
            .addCase(downloadQuotePDF.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "downloadQuotePDF"
            })
            .addCase(downloadQuotePDF.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "downloadQuotePDF"
            })
            .addCase(downloadQuotePDF.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "downloadQuotePDF"
            })
            .addCase(uploadSignedApplicationFile.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "uploadSignedApplicationFile"
            })
            .addCase(uploadSignedApplicationFile.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "uploadSignedApplicationFile"
            })
            .addCase(uploadSignedApplicationFile.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "uploadSignedApplicationFile"
            })
            .addCase(uploadLossRunFile.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "uploadLossRunFile"
            })
            .addCase(uploadLossRunFile.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "uploadLossRunFile"
            })
            .addCase(uploadLossRunFile.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "uploadLossRunFile"
            })
            .addCase(bindYourQuote.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "bindYourQuote"
            })
            .addCase(bindYourQuote.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "bindYourQuote"
            })
            .addCase(bindYourQuote.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "bindYourQuote"
            })
            .addCase(downloadAppFormPDF.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "downloadAppFormPDF"
            })
            .addCase(downloadAppFormPDF.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "downloadAppFormPDF"
            })
            .addCase(downloadAppFormPDF.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "downloadAppFormPDF"
            })
            .addCase(renewApplication.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "renewApplication"
            })
            .addCase(renewApplication.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "renewApplication"
            })
            .addCase(renewApplication.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "renewApplication"
            })
            .addCase(downloadLossRunsFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "downloadLossRunsFiles"
            })
            .addCase(downloadLossRunsFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "downloadLossRunsFiles"
            })
            .addCase(downloadLossRunsFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "downloadLossRunsFiles"
            })
            .addCase(deleteLossRunsFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "deleteLossRunsFiles"
            })
            .addCase(deleteLossRunsFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "deleteLossRunsFiles"
            })
            .addCase(deleteLossRunsFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "deleteLossRunsFiles"
            })
            .addCase(downloadSignedApplicationFile.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "downloadSignedApplicationFile"
            })
            .addCase(downloadSignedApplicationFile.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "downloadSignedApplicationFile"
            })
            .addCase(downloadSignedApplicationFile.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "downloadSignedApplicationFile"
            })
            .addCase(deleteSignedApplicationFile.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "deleteSignedApplicationFile"
            })
            .addCase(deleteSignedApplicationFile.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "deleteSignedApplicationFile"
            })
            .addCase(deleteSignedApplicationFile.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "deleteSignedApplicationFile"
            })
            .addCase(getUnderwriterReferralReasonQuestionMaps.fulfilled, (state, action) => {
                state.underwriterReferralReasonQuestionMaps = action.payload
                state.fetchStatus = "success"
                state.action = "getUnderwriterReferralReasonQuestionMaps"
            })
            .addCase(getUnderwriterReferralReasonQuestionMaps.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getUnderwriterReferralReasonQuestionMaps"
            })
            .addCase(getUnderwriterReferralReasonQuestionMaps.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getUnderwriterReferralReasonQuestionMaps"
            })
            .addCase(uploadSurplusLineFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "uploadSurplusLineFiles"
            })
            .addCase(uploadSurplusLineFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "uploadSurplusLineFiles"
            })
            .addCase(uploadSurplusLineFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "uploadSurplusLineFiles"
            })
            .addCase(uploadTriaFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "uploadTriaFiles"
            })
            .addCase(uploadTriaFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "uploadTriaFiles"
            })
            .addCase(uploadTriaFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "uploadTriaFiles"
            })
            .addCase(downloadTriaFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "downloadTriaFiles"
            })
            .addCase(downloadTriaFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "downloadTriaFiles"
            })
            .addCase(downloadTriaFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "downloadTriaFiles"
            })
            .addCase(deleteTriaFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "deleteTriaFiles"
            })
            .addCase(deleteTriaFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "deleteTriaFiles"
            })
            .addCase(deleteTriaFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "deleteTriaFiles"
            })
            .addCase(downloadSurplusLinesFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "downloadSurplusLinesFiles"
            })
            .addCase(downloadSurplusLinesFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "downloadSurplusLinesFiles"
            })
            .addCase(downloadSurplusLinesFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "downloadSurplusLinesFiles"
            })
            .addCase(deleteSurplusLinesFiles.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "deleteSurplusLinesFiles"
            })
            .addCase(deleteSurplusLinesFiles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "deleteSurplusLinesFiles"
            })
            .addCase(deleteSurplusLinesFiles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "deleteSurplusLinesFiles"
            })
    }
})

export default applicationSlice

export const { name, actions, reducers } = applicationSlice
